<script>
    import { scale } from 'svelte/transition';
    import { tweened } from 'svelte/motion';
    import { cubicOut } from 'svelte/easing';
    export let value = '';
    export let placeholder = '';
    export let buttonText = '';
    export let textActive = false;

    const progress = tweened({
        width: 100,
        margin: 0,
        padding: 0.5
    }, {
        duration: 200,
        easing: cubicOut
    });

    $: progress.set(textActive ? {width: 50, margin: 0.25, padding: 0.25} : {width: 100, margin: 0, padding: 0.5});
</script>

<div transition:scale class="w-full bg-gray-200 rounded p-0 relative shadow-lg p-0">
    {#if textActive}
        <input class="mb-2 bg-gray-200 appearance-none rounded py-2 px-4 text-gray-700 focus:outline-none focus:bg-white focus:border-gray-300 m-0 absolute"
            style="width: {95 - $progress.width}%"
            placeholder="{placeholder}"
            type="text"
            bind:value />
    {/if}
    <button class="block font-bold rounded ml-auto bg-red-500 h-full px-4 text-gray-800"
        style="width: {$progress.width}%; padding-top: {$progress.padding}rem; padding-bottom: {$progress.padding}rem;
            margin-top: {$progress.margin}rem; margin-right: {$progress.margin}rem; margin-bottom: {$progress.margin}rem;" on:click>
        {buttonText}
    </button>
</div>
